<template>
  <div>
    <div v-if="isStampRally" class="footer">
      <FaceAnimation
        :url="masterSheet.content.sheet_animation_image_url || String()"
        :isSheet="true"
        :isStampRally="true"
      />
    </div>

    <!-- 有効時間内であればカウントダウン・アニメーション表示 -->
    <div
      v-else-if="countDown != null && countDown != '00:00:00:00'"
      class="footer"
    >
      <!-- カウントダウン -->
      <FaceCountDown :countDown="countDown" />

      <!-- アニメーション-->
      <FaceAnimation
        :url="masterSheet.content.sheet_animation_image_url || String()"
        :isSheet="true"
      />
    </div>

    <!-- 有効時間外であれば黒画面 -->
    <FaceEndMessage v-else />

    <!-- チェック日時 -->
    <SFaceCheckinDateTime :stamped_at="frame.stamped_at" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import myTicketsCommonService from "@/services/common/myTickets";

export default {
  name: "TheSheetUsedLower",
  setup() {
    const store = useStore();

    const frame = computed(() => store.getters["ticketing/frame"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    const countDown = ref(null);

    const isStampRally = computed(() => {
      return (
        masterBook.value?.content?.description_json?.MbDisplayType ===
        "StampRally"
      );
    });

    onMounted(() => {
      updateCountDown();
      setInterval(() => updateCountDown(), 1 * 1000);
    });

    const updateCountDown = () => {
      if (frame.value.stamped_at) {
        const limit = myTicketsCommonService.getCountDownLimit(
          frame.value.stamped_at,
          masterSheet.value.content.description_json.FaceCountDown
        );

        countDown.value = myTicketsCommonService.getCountDown(limit);
      }
    };

    return {
      masterSheet,
      frame,
      countDown,
      isStampRally,
    };
  },
};
</script>
